module.exports = __webpack_public_path__ + "static/media/favicon_de.01774977.png";